import type { JanusCallSetters } from './sessionRefs';
import { logJanus } from './utils';

export function applyRemoteInboundAudio(
  track: MediaStreamTrack,
  eventStream: MediaStream | undefined,
  set: JanusCallSetters,
  meta: { handle: number }
): void {
  if (track.kind !== 'audio') return;

  track.enabled = true;

  const stream = eventStream ?? new MediaStream([track]);
  stream.getAudioTracks().forEach((t) => {
    t.enabled = true;
  });
  logJanus('IN', 'remote track', {
    handle: meta.handle,
    audioTracks: stream.getAudioTracks().length,
    trackState: track.readyState,
    enabled: track.enabled,
    muted: track.muted,
  });
  set.setRemoteStream(stream);

  if (track.muted) {
    const onUnmute = () => {
      track.removeEventListener('unmute', onUnmute);
      logJanus('IN', 'remote track unmuted — refresh playback', { handle: meta.handle });
      set.setRemoteStream(new MediaStream([track]));
    };
    track.addEventListener('unmute', onUnmute);
  }
}
